var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DataRecordList"},[_c('summary-report-config-form-button',{attrs:{"newForm":""}}),_c('v-container',[_c('v-row',[_c('v-col',[(_vm.lookupsReady)?_c('summary-report-table',{attrs:{"summaryReports":_vm.summaryReports}}):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }